export enum State {
  INIT = 'init',

  SELECT_YOURSELF = 'select-yourself',

  SEND_OFFICER_DATA = 'send-officer-data',

  BUSINESS_ROLE = 'business-role',
  SEND_BUSINESS_ROLE = 'send-business-role',

  PERSONAL_ADDRESS = 'personal-address',

  COMPLIANCE = 'compliance',

  NAME = 'name',
  SEND_NAME = 'send-name',

  ONLY_CORPORATE_OFFICER = 'only-corporate-officer',

  ABORT_TO_RESET_PROMPT = 'abort-to-reset-prompt',

  DONE = 'done',
  ABORT = 'abort',
}
